import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import { View, Text, TouchableOpacity, ScrollView, TextInput, ActivityIndicator, useWindowDimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { fontFamily } from '../../helpers/fontFamily';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation, useRoute } from '@react-navigation/native';
import { UpdateProductInfo, saveProductDataLocally, clearSavedProductData } from '../../actions/productAction';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { createInventoryReportItems, pushInventoryToShopify } from '../../actions/inventoryReportActions';
import ActionButtons from '../inventoryReports/actionButtons'
import PushOptionsDropdown from '../inventoryReports/pushOptionsDropdown'
import { showInventoryReport } from '../../actions/inventoryReportActions';
import { showMessage } from "react-native-flash-message";
import DeleteConfirmationModal from '../inventoryReports/deleteConfirmationModal';
import { Svg, Path } from 'react-native-svg';
import { useScreenWidth, useAutoScrollOnWidthChange } from './use-mobile';
import InventoryTableDataText from './inventoryTableData';

const viewInvetoryReport = () => {
  const route = useRoute();
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const {width: windowWidth} = useWindowDimensions();
  const savedProductData = useSelector(state => state.product.savedProductData);
  const [isEditing, setIsEditing] = useState(false);
  const [editedQuantities, setEditedQuantities] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loaderTitle, setLoaderTitle] = useState('Loading...');
  const [report, setReport] = useState('');
  const [inventoryReport, setIsInventoryReport] = useState([]);
  const [inventoryName, setIsInvertoryName] = useState('');
  const [originalQuantities, setOriginalQuantities] = useState({});
  const [lockedShopifyAfterValues, setLockedShopifyAfterValues] = useState({});
  const [editedShopifyAfterValues, setEditedShopifyAfterValues] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [inventoryData, setInventoryData] = useState(null);
  const [selectedOption, setSelectedOption] = useState('');
  const inputRef = useRef(null);
  const [mode, setMode] = useState('');
  const scrollViewRef = useRef(null);

  const [pushOption, setPushOption] = useState('push_updated_gp');
  const [showPushOptionsDropdown, setShowPushOptionsDropdown] = useState(false);
  const [preventRecalculation, setPreventRecalculation] = useState(false);

  const screenWidth = useScreenWidth()
  useAutoScrollOnWidthChange(screenWidth, scrollViewRef, 0.26);
  const isMobile = screenWidth < 600;

  const getShopifyInventoryForProduct = (productId) => {
    if (!inventoryData?.inventory_data) return null;
    return inventoryData.inventory_data.find(item => item.product_id === productId);
  };

  const isProductFromOtherStore = (productId) => {
    const shopifyInventory = getShopifyInventoryForProduct(productId);
    return shopifyInventory?.is_other_store_product || false;
  };

  const shouldShowPushOptionsDropdown = () => {
    return route.params?.from === 'pushInventory' && mode === 'receive' && selectedOption === 'available';
  };

  const getButtonText = () => {
    if (mode === 'recount') {
      return 'Push New Count To Shopify';
    } else if (mode === 'receive') {
      if (selectedOption === 'available') {
        return 'Confirm and Push';
      } else if (selectedOption === 'incoming') {
        return 'Push New Incoming to Shopify';
      }
    }
    return 'Push Inventory';
  };

  const calculateShopifyAfterValues = (selectedPushOption) => {
    if (!shouldShowPushOptionsDropdown()) return;

    const newEditedShopifyAfterValues = {};

    inventoryReport.forEach(item => {
      const receivedValue = isEditing
        ? item.quantity_to_receive || 0
        : (editedQuantities[item.id]?.after || item.quantity_to_receive || 0);

      if (selectedPushOption === 'push_received_difference') {
        const shopifyInventory = getShopifyInventoryForProduct(item.product_id);
        const shopifyBefore = shopifyInventory ? shopifyInventory[selectedOption] || 0 : 0;
        newEditedShopifyAfterValues[item.id] = shopifyBefore + parseInt(receivedValue, 10);
      } else if (selectedPushOption === 'push_updated_gp') {
        newEditedShopifyAfterValues[item.id] = item.current_quantity_on_hand + parseInt(receivedValue, 10);
      }
    });

    setEditedShopifyAfterValues(newEditedShopifyAfterValues);
  };

  const handlePushOptionChange = (option) => {

    setPushOption(prevOption => {
      return option;
    });

    calculateShopifyAfterValues(option);
  };

  // useEffect(() => {
  //   console.log('pushOption state changed to:', pushOption);
  // }, [pushOption]);

  useEffect(() => {
      if (shouldShowPushOptionsDropdown() && inventoryReport.length > 0 && !isEditing) {
    if (Object.keys(lockedShopifyAfterValues).length === 0) {
      calculateShopifyAfterValues(pushOption);
    }
  }
  }, [inventoryReport, pushOption, isEditing, preventRecalculation]);

  useEffect(() => {
    const fetchMode = async () => {
      const storedMode = await AsyncStorage.getItem('current_report_mode');
      if (storedMode) setMode(storedMode);
    };
    fetchMode();
  }, []);

  useEffect(() => {
    if (route.params?.from === 'pushInventory') {
      setInventoryData(route.params?.inventoryData);
      setSelectedOption(route.params?.selectedOption || '');
      setEditedShopifyAfterValues({});
      setLockedShopifyAfterValues({});
    }
  }, [route.params]);

  const handleBack = async () => {
    try {
      if (route.params?.from === 'archived') {
        navigation.navigate('ArchivedReceivingReports', { mode });
      } else if (route.params?.from === 'pushInventory') {
        navigation.navigate('PushInventory', {
          mode: mode,
          timestamp: new Date().getTime()
        });
      } else if (route.params?.from === 'done_button') {
        if (mode === 'receive') {
          navigation.navigate('ScanReceive');
        } else {
          navigation.navigate('ScanRecount');
        }
      } else {
        navigation.navigate('InventoryReport', { mode });
      }
    } catch (error) {
      console.error('Error reading mode from storage:', error);
    }
  };

  const handleEdit = () => {
    const initialQuantities = {};
    const initialEditedQuantities = {};
    const initialShopifyAfterValues = {};
    const initialEditedShopifyAfterValues = {};

    if (route.params?.view === 'show') {
      inventoryReport.forEach(item => {
        const originalValue = item.quantity_to_receive;
        const beforeValue = mode === 'receive'
          ? item.final_quantity_on_hand
          : item.current_quantity_on_hand;

        const uiDisplayValue = mode === 'receive'
          ? item.final_quantity_on_hand
          : item.current_quantity_on_hand + item.discrepancy;

        const currentlyDisplayedShopifyAfter = mode === 'receive' ? item.final_quantity_on_hand : item.current_quantity_on_hand + (item.discrepancy || 0);
        initialQuantities[item.id] = originalValue;
        initialEditedQuantities[item.id] = {
          before: beforeValue,
          after: originalValue,
          uiDisplayValue: uiDisplayValue
        };
        initialShopifyAfterValues[item.id] = currentlyDisplayedShopifyAfter;
        initialEditedShopifyAfterValues[item.id] = editedShopifyAfterValues[item.id] || currentlyDisplayedShopifyAfter;
      });
    }

    setOriginalQuantities(initialQuantities);
    setLockedShopifyAfterValues(initialShopifyAfterValues);
    setEditedQuantities(initialEditedQuantities);
    setEditedShopifyAfterValues(initialEditedShopifyAfterValues);
    setIsEditing(true);
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  const handleQuantityChange = (productId, value) => {
    setEditedQuantities(prev => {
      let newUiDisplayValue = 0;

      if (route.params?.view === 'show') {
        const item = inventoryReport.find(item => item.id == productId);
        if (item) {
          newUiDisplayValue = lockedShopifyAfterValues[productId] ?? (mode === 'receive'
            ? item.current_quantity_on_hand + parseInt(value, 10)
            : parseInt(value, 10));
        }
      }

      const newQuantities = {
        ...prev,
        [productId]: {
          before: prev[productId]?.before || 0,
          after: value,
          uiDisplayValue: newUiDisplayValue
        }
      };
      return newQuantities;
    });
  };

  const handleShopifyAfterChange = (productId, value) => {
    setEditedShopifyAfterValues(prev => ({
      ...prev,
      [productId]: value
    }));
  };

  const handleSaveEdit = () => {
    if (route.params?.view === 'show') {
      const updatedInventoryReport = inventoryReport.map(item => {
        if (editedQuantities[item.id] !== undefined) {
          const newQuantityToReceive = parseInt(editedQuantities[item.id].after, 10);
          if (!isNaN(newQuantityToReceive)) {
            return {
              ...item,
              quantity_to_receive: newQuantityToReceive,
         final_quantity_on_hand: mode === 'receive'
           ? item.current_quantity_on_hand + newQuantityToReceive
           : newQuantityToReceive,
         discrepancy: mode === 'recount'
           ? newQuantityToReceive - item.current_quantity_on_hand
           : item.discrepancy
            };
          }
        }
        return item;
      });
      setIsInventoryReport(updatedInventoryReport);
    }

    if (shouldShowPushOptionsDropdown()) {
      setLockedShopifyAfterValues(prev => ({ ...prev, ...editedShopifyAfterValues }));
    }

    setIsEditing(false);
    route.params?.from !== 'pushInventory' && setEditedQuantities({});
  };


  const handleConfirm = () => {
    setShowDeleteModal(true);
  }

  const handleViewAndPush = () => {
    setEditedShopifyAfterValues({});
    setLockedShopifyAfterValues({});

    navigation.navigate('PushInventory', {
      mode: mode,
      reportId: route.params?.id,
      timestamp: new Date().getTime()
    });
  };

  const handlePushConfirm = async () => {
    if (route.params?.from === 'pushInventory') {
      await handleActualPushToShopify();
      return;
    }

    try {
      setShowDeleteModal(false);
      setIsLoading(true);
      setLoaderTitle('Saving Changes...');
      const currentReportId = route.params?.id || await AsyncStorage.getItem('current_report_id');

      if (!currentReportId) {
        setIsLoading(false);
        return;
      }
      dispatch({ type: 'CLEAR_INVENTORY_REPORTS' });
      dispatch(clearSavedProductData());

      if (inventoryReport && inventoryReport.length > 0) {
        const updatePromises = inventoryReport.map(item => {
          const productData = {
            basicinfo: {
              name: item.name,
              id: item.product_id
            },
            inventory_warehouses: [{
              info: {
                quantity_on_hand: item.final_quantity_on_hand,
                available_inv: item.current_quantity_on_hand
              }
            }],
            skus: [{ sku: item.sku }]
          };

          return Promise.all([
            dispatch(UpdateProductInfo(item.product_id, productData)),
            dispatch(createInventoryReportItems({
              id: currentReportId,
              name: item.name,
              quantity_to_receive: item.quantity_to_receive,
              final_quantity_on_hand: item.final_quantity_on_hand,
              current_quantity_on_hand: item.current_quantity_on_hand,
              discrepancy: item.discrepancy,
              mode: mode,
              sku: item.sku || '',
              product_id: item.product_id,
              report_status: 'received'
            }))
          ]);
        });

        await Promise.all(updatePromises);
        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      navigation.navigate('PushInventory', {
        mode: mode,
        reportId: currentReportId,
        timestamp: new Date().getTime()
      });
    } catch (error) {
      console.error('Error in handlePushConfirm:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleActualPushToShopify = async () => {
    try {
      setIsLoading(true);
      setLoaderTitle('Pushing inventory to Shopify...');

      const reportId = route.params?.id;
      const selectedLocation = route.params?.selectedLocation;
      const selectedOption = route.params?.selectedOption;

      if (!reportId || !selectedLocation || !selectedOption) {
        showMessage({
          message: 'The Inventory cannot be pushed for this product',
          type: "danger",
          backgroundColor: '#d40202',
          duration: 5000
        });
        return;
      }

      let productUpdates = [];

      if (inventoryReport && inventoryReport.length > 0) {
        productUpdates = inventoryReport.map(item => {
          const shopifyInventory = getShopifyInventoryForProduct(item.product_id);
          const isManualProduct = shopifyInventory?.is_manual_product || false;
          if (isManualProduct) return null;
          const isOtherStoreProduct = isProductFromOtherStore(item.product_id);
          let shopifyAfter;

          if (editedShopifyAfterValues[item.id] !== undefined) {
            shopifyAfter = editedShopifyAfterValues[item.id];
          } else if (lockedShopifyAfterValues[item.id] !== undefined) {
            shopifyAfter = lockedShopifyAfterValues[item.id];
          } else if (isOtherStoreProduct) {
            if (mode === 'receive') {
              shopifyAfter = Math.abs(item.quantity_to_receive || 0);
            } else {
              shopifyAfter = Math.abs(item.final_quantity_on_hand || item.quantity_to_receive || 0);
            }
          } else {
            shopifyAfter = mode === 'receive' ? item.final_quantity_on_hand : item.current_quantity_on_hand + (item.discrepancy || 0);
          }

          return {
            product_id: item.product_id,
            shopify_after_value: shopifyAfter,
            location_id: shopifyInventory?.location_id,
            is_default_location: shopifyInventory?.is_default_location || false
          };
        }).filter(item => item !== null);
      } else if (savedProductData && savedProductData.length > 0) {
        productUpdates = savedProductData.map(item => {
          const shopifyInventory = getShopifyInventoryForProduct(item.product.id);
          const isManualProduct = shopifyInventory?.is_manual_product || false;

          if (isManualProduct) {
            return null;
          }

          const receivedQuantity = mode === 'receive'
            ? item.product.inventory_warehouses[0].info.quantity_on_hand - item.product.inventory_warehouses[0].info.available_inv
            : item.product.inventory_warehouses[0].info.quantity_on_hand;

          const isOtherStoreProduct = isProductFromOtherStore(item.product.id);
          let shopifyAfter;

          if (editedShopifyAfterValues[item.id] !== undefined) {
            shopifyAfter = editedShopifyAfterValues[item.id];
          } else if (lockedShopifyAfterValues[item.id] !== undefined) {
            shopifyAfter = lockedShopifyAfterValues[item.id];
          } else if (isOtherStoreProduct) {
            if (mode === 'receive') {
              shopifyAfter = Math.abs(receivedQuantity || 0);
            } else {
              shopifyAfter = Math.abs(item.product.inventory_warehouses[0].info.quantity_on_hand || 0);
            }
          } else {
            shopifyAfter = mode === 'receive'
              ? item.product.inventory_warehouses[0].info.quantity_on_hand
              : item.product.inventory_warehouses[0].info.quantity_on_hand;
          }

          return {
            product_id: item.product.id,
            shopify_after_value: shopifyAfter,
            location_id: shopifyInventory?.location_id,
            is_default_location: shopifyInventory?.is_default_location || false
          };
        }).filter(item => item !== null);
      }

      if (productUpdates.length === 0) {
        showMessage({
          message: 'No products found to push inventory',
          type: "danger",
          backgroundColor: '#d40202',
          duration: 5000
        });
        return;
      }

      const productIds = productUpdates.map(item => item.product_id);
      const result = await dispatch(pushInventoryToShopify(
        reportId,
        selectedLocation.id,
        selectedLocation.name,
        productIds,
        selectedOption,
        editedQuantities,
        productUpdates
      ));

      if (result.success) {
        showMessage({
          message: result.message || 'Inventory successfully updated and pushed to Shopify',
          type: "success",
          backgroundColor: '#4CAF50',
          duration: 5000
        });

        navigation.navigate('InventoryReport', { mode });
      } else {
        let errorMessage = result.error || 'Failed to push inventory to Shopify';
        showMessage({
          message: errorMessage,
          type: "danger",
          backgroundColor: '#d40202',
          duration: 7000
        });
      }

    } catch (error) {
      showMessage({
        message: 'Failed to push inventory to Shopify. Please try again.',
        type: "danger",
        backgroundColor: '#d40202',
        duration: 5000
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmed = async () => {
    try {
      setShowDeleteModal(false);
      setIsLoading(true);
      setLoaderTitle('Saving Changes...');
      const currentReportId = route.params?.id || await AsyncStorage.getItem('current_report_id');

      if (!currentReportId) {
        setIsLoading(false);
        return;
      }
      dispatch({ type: 'CLEAR_INVENTORY_REPORTS' });
      dispatch(clearSavedProductData());

      if (inventoryReport && inventoryReport.length > 0) {
        const updatePromises = inventoryReport.map(item => {
          const productData = {
            basicinfo: {
              name: item.name,
              id: item.product_id
            },
            inventory_warehouses: [{
              info: {
                quantity_on_hand: item.final_quantity_on_hand,
                available_inv: item.current_quantity_on_hand
              }
            }],
            skus: [{ sku: item.sku }]
          };

          return Promise.all([
            dispatch(UpdateProductInfo(item.product_id, productData)),
            dispatch(createInventoryReportItems({
              id: currentReportId,
              name: item.name,
              quantity_to_receive: item.quantity_to_receive,
              final_quantity_on_hand: item.final_quantity_on_hand,
              current_quantity_on_hand: item.current_quantity_on_hand,
              discrepancy: item.discrepancy,
              mode: mode,
              sku: item.sku || '',
              product_id: item.product_id,
              report_status: 'received'
            }))
          ]);
        });

        await Promise.all(updatePromises);
        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      navigation.navigate('InventoryReport', {
        mode: mode,
        refresh: true,
        timestamp: new Date().getTime()
      });

    } catch (error) {
      console.error('Error in handleConfirmed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = async () => {
    if (mode == 'receive') {
      navigation.navigate('ScanReceive');
    } else {
      navigation.navigate('ScanRecount');
    }
  };

  const formatWithSign = (num) => {
    const positiveNumber = Number(num) || 0;
    return positiveNumber > 0 ? `+${positiveNumber}` : `${positiveNumber}`;
  };


  const revertChange = () => {
    const revertedQuantities = {};

    if (route.params?.view === 'show') {
      inventoryReport.forEach(item => {
        if (originalQuantities[item.id] !== undefined) {
          const originalValue = originalQuantities[item.id];
          const beforeValue = mode === 'receive'
            ? item.final_quantity_on_hand
            : item.current_quantity_on_hand;

          const originalUiDisplayValue = mode === 'receive'
            ? item.final_quantity_on_hand
            : item.current_quantity_on_hand + item.discrepancy;

          revertedQuantities[item.id] = {
            before: beforeValue,
            after: originalValue,
            uiDisplayValue: originalUiDisplayValue
          };
        }
      });
    }

    setEditedQuantities(revertedQuantities);
    setLockedShopifyAfterValues({});
    setEditedShopifyAfterValues({});
    setIsEditing(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  useEffect(() => {
    const showReport = async (id) => {
      try {
        const response = await dispatch(showInventoryReport(id));
        setIsInvertoryName(response?.inventory_report?.name)
        setIsInventoryReport(response?.inventory_report_items)
      } catch (error) {
        showMessage({
          message: "Failed to load report details.",
          type: "danger",
        });
      }
    };

    if (route.params?.id) {
      showReport(route.params.id);
    }
  }, [route.params?.id]);


  useEffect(() => {
    const getReport = async () => {
      try {
        const reportString = await AsyncStorage.getItem('current_report');
        if (reportString) {
          const reportData = JSON.parse(reportString);
          setReport(reportData);
        }
      } catch (error) {
        console.error('Error getting report:', error);
      }
    };

    getReport();
  }, []);


  const NumberInputControl = React.memo(
    React.forwardRef(({ value, onChange }, ref) => {
      const inputRef = useRef(null);
      const [internalValue, setInternalValue] = useState(value || '');

      useEffect(() => {
        if (value !== internalValue) {
          setInternalValue(value || '');
        }
      }, [value]);

      useImperativeHandle(ref, () => ({
        focus: () => inputRef.current?.focus(),
      }), []);

      const handleTextChange = (text) => {
        const numeric = text.replace(/[^0-9]/g, '');
        setInternalValue(numeric);
      };

      const handleBlur = () => {
        if (internalValue !== value) {
          onChange(internalValue || '0');
        }
      };

      const updateValue = (newVal) => {
        setInternalValue(newVal);
        onChange(newVal);
        setTimeout(() => {
          inputRef.current?.focus();
        }, 0);
      };

      const handleIncrement = () => {
        const newValue = ((parseInt(internalValue) || 0) + 1).toString();
        updateValue(newValue);
      };

      const handleDecrement = () => {
        const newValue = Math.max(0, (parseInt(internalValue) || 0) - 1).toString();
        updateValue(newValue);
      };

      return (
        <View style={{
          position: 'relative',
          width: isMobile ? 75 : 96,
          textAlign: 'right',
          minWidth: isMobile ? 75 : 96,
        }}>
          <TextInput
            ref={inputRef}
            style={{
              backgroundColor: '#fff',
              color: '#000',
              padding: 5,
              borderRadius: 5,
              width: '100%',
              textAlign: 'center',
              fontSize: 16,
              height: 30,
            }}
            keyboardType="numeric"
            value={internalValue}
            onChangeText={handleTextChange}
            onBlur={handleBlur}
            blurOnSubmit={false}
            selectTextOnFocus={true}
          />
          <View style={{
            position: 'absolute',
            right: -2,
            top: 0,
            height: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
            width: 20,
          }}>
            <TouchableOpacity onPress={handleIncrement} style={{
              width: 18,
              height: 15,
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                <Path d="M17 15L12 10L7 15" stroke="#000000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </Svg>
            </TouchableOpacity>
            <TouchableOpacity onPress={handleDecrement} style={{
              width: 18,
              height: 15,
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ transform: [{ rotate: '180deg' }] }}>
                <Path d="M17 15L12 10L7 15" stroke="#000000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </Svg>
            </TouchableOpacity>
          </View>
        </View>
      );
    })
  );

  return (
    <View
      testID="viewInventoryReportScrollContainer"
      style={{
        height:
          windowWidth >= 900 ? 'calc(100vh - 64px)' : 'calc(100vh - 40px)',
        overflow: 'auto'
      }}>
    <LinearGradient
      colors={['#0A1118',
        '#111C29',
        '#253C57',
        '#5C778F',
        '#5C778F',
        '#253C57',
        '#111B27']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      locations={[0.09, 0.19, 0.43, 0.58, 0.78, 0.92]}
      style={{
        position: 'relative',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        alignItems: 'center',
        zIndex: 1000,
        width: '100%',
        minHeight: '100%',
        paddingBottom: 20
      }}
    >
      <DeleteConfirmationModal
        visible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmed}
        isApplyRecord={true}
      />

      {isLoading ? (
        <View style={{ justifyContent: 'center', flex: 1 }}>
          <ActivityIndicator size="large" color="white" />
          <View>
            <Text style={{ textAlign: 'center', color: 'white', fontSize: 16 }}>
              {loaderTitle}
            </Text>
          </View>
        </View>
      ) : (
        <>
          <View style={{
            backgroundColor: '#0F0F0F',
            padding: '25px',
            width: '100%',
            height: 34,
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Text style={{
              color: '#ffffff',
              fontSize: 16,
              fontFamily: fontFamily.font600,
              width: '100%',
              textAlign: 'center'
            }}>
              {mode === 'receive' ? 'Receiving Record' : 'Recount Record'}
            </Text>
          </View>

          <View style={{
            width: '100%',
            padding: '2%',
            boxSizing: 'border-box',
            alignItems: 'center'
          }}>
            <View style={{
              width: '100%',
              maxWidth: route.params?.from === 'pushInventory' && selectedOption ? 970 : 780,
              margin: '0 auto',
              display: 'flex',
              paddingHorizontal: 10
            }}>
              <TouchableOpacity
                style={{
                  borderWidth: 1,
                  borderColor: '#ffffff',
                  borderRadius: 15,
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 68,
                  height: 26,
                  paddingHorizontal: 14,
                  paddingVertical: 3,
                  alignSelf: 'flex-start',
                  marginTop: 20,
                  marginLeft: 10
                }}
                onPress={route.params?.view === 'show' ? () => handleBack() : () => handleCancel()}
              >
                <Text style={{ color: '#ffffff', fontFamily: fontFamily.font300, fontSize: 16 }}>back</Text>
              </TouchableOpacity>
            </View>
          </View>

          <View style={{
            padding: '2%',
            width: '100%',
            boxSizing: 'border-box',
            alignItems: 'center'
          }}>
            <Text style={{
              color: '#ffffff',
              fontSize: 14,
              fontFamily: fontFamily.font600,
              width: '90%',
              maxWidth: 780,
              margin: '0 auto',
              display: 'block',
              textAlign: 'center'
            }}>
              Edited {report.updated_at ? formatDate(report.updated_at) : 'N/A'} by GPADMIN
            </Text>
          </View>

          <View style={{
            width: '100%',
            minHeight: 56,
            justifyContent: 'center',
            alignItems: 'center',
            paddingHorizontal: 20
          }}>
            {shouldShowPushOptionsDropdown() && !isEditing ? (
              <View style={{
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
                maxWidth: 970,
                gap: 40,
                paddingLeft: isMobile ? '15%' : '12%'
              }}>
                <PushOptionsDropdown
                  shouldShowPushOptionsDropdown={shouldShowPushOptionsDropdown}
                  isEditing={isEditing}
                  pushOption={pushOption}
                  showPushOptionsDropdown={showPushOptionsDropdown}
                  setShowPushOptionsDropdown={setShowPushOptionsDropdown}
                  handlePushOptionChange={handlePushOptionChange}
                />

                <ActionButtons
                  isEditing={isEditing}
                  handleEdit={handleEdit}
                  handleCancel={handleCancel}
                  handleConfirm={handleConfirm}
                  handlePushConfirm={handlePushConfirm}
                  handleViewAndPush={handleViewAndPush}
                  handleSaveEdit={handleSaveEdit}
                  revertChange={revertChange}
                  isCancelButtons={route.params?.view === 'show' ? true : false}
                  fromPushInventory={route.params?.from === 'pushInventory'}
                  fromDoneButton={route.params?.from === 'done_button'}
                  mode={mode}
                  selectedOption={selectedOption}
                  getButtonText={getButtonText}
                  isHorizontalLayout={true}
                />
              </View>
            ) : (
              <ActionButtons
                isEditing={isEditing}
                handleEdit={handleEdit}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
                handlePushConfirm={handlePushConfirm}
                handleViewAndPush={handleViewAndPush}
                handleSaveEdit={handleSaveEdit}
                revertChange={revertChange}
                isCancelButtons={route.params?.view === 'show' ? true : false}
                fromPushInventory={route.params?.from === 'pushInventory'}
                fromDoneButton={route.params?.from === 'done_button'}
                mode={mode}
                selectedOption={selectedOption}
                getButtonText={getButtonText}
                isHorizontalLayout={false}
              />
            )}
          </View>

          <View style={{
            width: `${isMobile ? `${screenWidth}px` : "100%"}`,
            maxWidth: route.params?.from === 'pushInventory' && selectedOption ? 970 : 780,
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: -1
          }}>
            <LinearGradient
              colors={['#e6dddd17', '#ffffff66']}
              start = { {x: 0.5, y: 1 }}
              end   = { {x: 0.5, y: 0 }}
              style={{
                padding: 7,
                borderTopLeftRadius: 22,
                borderTopRightRadius: 22,
                width: '100%',
                alignSelf: 'center',
                height: 35
              }}
            >
              <Text style={{
                color: '#ffffff',
                textAlign: 'center',
                fontSize: screenWidth < 300 ? 12 : 14,
                fontFamily: fontFamily.font600,
                }}
              >
              {mode === 'receive' ? 'Receiving Summary' : 'Recount Summary'}{'    '}
              {isMobile && (
                <Text>
                  {'<<'} Scroll to View {'>>'}
                </Text>)}
              </Text>
            </LinearGradient>
            <View
              style={{
                width: '100%',
                maxHeight: screenWidth > 600 ? 500 : 300,
                overflow: 'hidden',
              }}
            >
              <ScrollView
                showsVerticalScrollIndicator
                style={{ flex: 1 }}
                contentContainerStyle={{ flexGrow: 1 }}
              >
                <ScrollView
                  horizontal
                  showsHorizontalScrollIndicator={false}
                  ref={scrollViewRef}
                  scrollEventThrottle={16}
                  style={{ width: '100%' }}
                  contentContainerStyle={{ alignItems: 'flex-start' }}
                >
                  <View style={{ display: 'flex', flexDirection: 'column', zIndex: -1 }}>
                    <View style={{
                      flexDirection: 'row',
                      minWidth: isMobile
                        ? (route.params?.from === 'pushInventory' && selectedOption ? screenWidth * 2.2 : screenWidth * 1.5)
                        : (route.params?.from === 'pushInventory' && selectedOption ? 970 : 780),
                      justifyContent: 'space-between',
                      backgroundColor: 'rgba(0, 0, 0, 0.2)',
                      paddingHorizontal: 10,
                      height: (route.params?.from === 'pushInventory' && selectedOption ? 80 : 27),
                      display: (route.params?.from === 'pushInventory' && selectedOption ? 'flex' : ''),
                      alignItems: (route.params?.from === 'pushInventory' && selectedOption ? 'center' : '')
                    }}>
                      <InventoryTableDataText data={"SKU"} isMobile={isMobile} toLeft={true} isHeader={true}/>
                      <InventoryTableDataText data={"Item Name"} isMobile={isMobile} doubleWidth={true} toLeft={true} isHeader={true}/>
                      <InventoryTableDataText data={mode === 'receive' ? 'Before' : 'Previous'} isMobile={isMobile} isHeader={true}/>
                      <InventoryTableDataText data={mode === 'receive' ? 'Received' : 'Counted'} isMobile={isMobile} isHeader={true}/>
                      <InventoryTableDataText data={mode === 'receive' ? 'After' : 'Diff'} isMobile={isMobile} isHeader={true}/>
                      <InventoryTableDataText data={'Username'} isMobile={isMobile} isHeader={true}/>
                      {route.params?.from === 'pushInventory' && selectedOption && (
                        <>
                          <InventoryTableDataText data={`Shopify ${selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1)} Before`} isMobile={isMobile} isHeader={true}/>
                          <InventoryTableDataText data={`Shopify ${selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1)} After`} isMobile={isMobile} isHeader={true}/>
                        </>
                      )}
                    </View>

                    {route.params?.view === 'show' ? (
                      <>
                        {inventoryReport.map((item, index) => {
                          const shopifyInventory = getShopifyInventoryForProduct(item.product_id);
                          const isManualProduct = shopifyInventory?.is_manual_product || false;
                          const isPushDisabled = shopifyInventory?.is_push_disabled || false;

                          let shopifyBefore;
                          if (isManualProduct) {
                            shopifyBefore = 'Not available';
                          } else if (isPushDisabled) {
                            shopifyBefore = 'Push disabled';
                          } else {
                            shopifyBefore = shopifyInventory ? shopifyInventory[selectedOption] || 0 : 0;
                          }

                          let shopifyAfter;
                          if (isManualProduct) {
                            shopifyAfter = 'Not available';
                          } else if (isPushDisabled) {
                            shopifyAfter = 'Push disabled';
                          } else if (editedShopifyAfterValues[item.id] !== undefined) {
                            shopifyAfter = editedShopifyAfterValues[item.id];
                          } else if (lockedShopifyAfterValues[item.id] !== undefined) {
                            shopifyAfter = lockedShopifyAfterValues[item.id];
                          } else {
                              const afterValue = mode === 'receive' ? item?.final_quantity_on_hand : item?.current_quantity_on_hand + (item?.discrepancy || 0);
                              shopifyAfter = afterValue;
                          }

                          return (
                            <View key={index} style={{
                              display: 'flex',
                              width: isMobile
                                ? (route.params?.from === 'pushInventory' && selectedOption ? screenWidth * 2.2 : screenWidth * 1.5)
                                : (route.params?.from === 'pushInventory' && selectedOption ? 970 : 780),
                              justifyContent: 'space-between',
                              padding: `${isMobile ? `1%` : "2%"}`,
                              boxSizing: 'border-box',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}>
                              <InventoryTableDataText data={item?.sku || 'No SKU'} isMobile={isMobile} toLeft={true}/>
                                <InventoryTableDataText data={item?.name} isMobile={isMobile} doubleWidth={true} toLeft={true}/>
                              <InventoryTableDataText data={item?.current_quantity_on_hand} isMobile={isMobile} />
                              {isEditing ? (
                                <NumberInputControl ref={inputRef} value={editedQuantities[item.id]?.after || 0} onChange={(value) => handleQuantityChange(item.id, value)} isMobile={isMobile} />
                              ) : (
                                <InventoryTableDataText data={item?.quantity_to_receive} isMobile={isMobile} />
                              )}
                              <InventoryTableDataText data={mode === 'receive' ? item?.final_quantity_on_hand : formatWithSign(item?.discrepancy)} isMobile={isMobile} />
                              <InventoryTableDataText data={item?.username ?? ''} isMobile={isMobile} />
                              {route.params?.from === 'pushInventory' && selectedOption && (
                                <>
                                  <InventoryTableDataText data={shopifyBefore} isMobile={isMobile} />
                                  {isEditing && !isManualProduct && !isPushDisabled ? (
                                    <NumberInputControl
                                      value={editedShopifyAfterValues[item.id] || shopifyAfter || 0}
                                      onChange={(value) => handleShopifyAfterChange(item.id, value)}
                                      isMobile={isMobile}
                                    />
                                  ) : (
                                    <InventoryTableDataText
                                      data={shopifyAfter}
                                      isMobile={isMobile}
                                      style={isPushDisabled ? { color: 'rgba(255, 255, 255, 0.5)' } : {}}
                                    />
                                  )}
                                </>
                              )}
                            </View>
                          );
                        })}
                      </>
                    ) : null}

                  </View>
                </ScrollView>
              </ScrollView>
            </View>
            <LinearGradient
              colors={['rgba(0, 0, 0, 0.1)', 'rgba(255, 255, 255, 0.3)']}
              start={{ x: 1, y: 0 }}
              end={{ x: 0, y: 0 }}
              style={{
                padding: 7,
                borderBottomLeftRadius: 22,
                borderBottomRightRadius: 22,
                width: '100%',
                alignSelf: 'center',
                height: 35
              }}
            />
          </View>

          <View style={{ width: '100%', alignItems: 'center' }}>
            <ActionButtons
              isEditing={isEditing}
              handleEdit={handleEdit}
              handleCancel={handleCancel}
              handleConfirm={handleConfirm}
              handlePushConfirm={handlePushConfirm}
              handleViewAndPush={handleViewAndPush}
              handleSaveEdit={handleSaveEdit}
              revertChange={revertChange}
              isCancelButtons={route.params?.view === 'show' ? true : false}
              fromPushInventory={route.params?.from === 'pushInventory'}
              fromDoneButton={route.params?.from === 'done_button'}
              mode={mode}
              selectedOption={selectedOption}
              getButtonText={getButtonText}
              isHorizontalLayout={false}
            />
          </View>
        </>
      )}
    </LinearGradient>
    </View>
  );
};

export default viewInvetoryReport;
